import 'react-multi-carousel/lib/styles.css';

import { CarouselWidget as ComponentLibraryCarousel } from '@orcha/micro-library-widgets-ui';
import { logEventAnalytic } from 'src/utilities/logAnalytics';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';

const CarouselWidget = (props) => {
  const { t } = useTranslation();
  return (
    <ComponentLibraryCarousel
      FlexibleImageComponent={Image}
      translatedText={{
        carouselWidgetLeftArrowTitle: t('carousel.leftArrowTitle'),
        carouselWidgetRightArrowTitle: t('carousel.rightArrowTitle'),
      }}
      itemClickHandler={(itemTitle) =>
        logEventAnalytic({
          category: 'Topic',
          action: 'Clicked on the topic carousel - microsite',
          label: `${itemTitle}`,
        })
      }
      {...props}
    />
  );
};

export default CarouselWidget;
